export const GLOBAL_NOTIFICATION_REQUEST = 'GLOBAL_NOTIFICATION_CHANGED';
export const GLOBAL_NOTIFICATION_DISMISSED = 'GLOBAL_NOTIFICATION_DISMISSED';
